import { Typography, Button, Space, Flex, Avatar } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../store";
import { currentDoctor } from "../../store/slices/user";
import useVideo from "../../hooks/useVideo";
import { endMeeting, startMeeting } from "../../store/slices/video";
import useCurrentUser from "../../hooks/useCurrentUser";

const { Title, Text } = Typography;

export function MeetingDetailsScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isDoctor } = useCurrentUser();
  const { meetingId } = useVideo();
  const doctor = useAppSelector(currentDoctor);
  const { state } = useLocation();

  const handleEndMeeting = () => {
    dispatch(endMeeting());
    navigate(-1);
  };

  return (
    <>
      <Space
        direction="vertical"
        size="middle"
        style={{ width: "100%", marginBottom: 43 }}
      >
        {!isDoctor && doctor?.photo ? (
          <Avatar size={121} src={<img src={doctor.photo} alt="avatar" />} />
        ) : null}
        <Title level={3} style={{ marginBottom: 0 }}>
          {isDoctor
            ? `${state?.appointment?.patient.name} ${state?.appointment?.patient.surname}`
            : `${t("global.labels.doctorPrefix")} ${doctor?.name} ${doctor?.surname}`}
        </Title>
        <Text type="secondary" style={{ fontSize: 18, lineHeight: "1.2" }}>
          {!isDoctor && doctor?.role === "oncologist"
            ? t("global.labels.oncologistInfo")
            : null}
          {!isDoctor && doctor?.role === "nutrizionist"
            ? t("global.labels.nutritionistInfo")
            : null}
          {isDoctor
            ? `${t("global.labels.patientFrom")} ${dayjs(
                state.appointment.patient.created_at
              )
                .format("YYYY")
                .toString()}`
            : null}
        </Text>
      </Space>
      <Flex gap={10}>
        <Button type="text" size="large" onClick={handleEndMeeting}>
          {t("global.button.goBack")}
        </Button>
        <Button
          type="primary"
          size="large"
          block
          onClick={async () => {
            if (meetingId) {
              dispatch(startMeeting());
            }
          }}
        >
          {t("global.button.joinNow")}
        </Button>
      </Flex>
    </>
  );
}
